import { render, staticRenderFns } from "./ListagemCompradoresHeader.vue?vue&type=template&id=2e43cfd2"
import script from "./ListagemCompradoresHeader.vue?vue&type=script&lang=js"
export * from "./ListagemCompradoresHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports